import { createSlice } from "@reduxjs/toolkit";
import { clearSelectedUserDispatch } from "../dispatch/user/clear-selected-user";
import { setSelectedUserDispatch } from "../dispatch/user/set-selected-user";
import { setUserPageDispatch } from "../dispatch/user/set-user-page";
import { setUserPageByDtoDispatch } from "../dispatch/user/set-user-page-by-dto";
import { RootState } from "../store";
import { UserState } from "../type/user-state";

const initialState: UserState = {
  selectedUser: undefined,
  userPage: {
    contents: [],
    first: true,
    last: true,
    page: 0,
    totalPages: 1,
    totalElements: 0,
  },
  status: "idle",
};

export const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    setUserPageByDtoAction: setUserPageByDtoDispatch,
    clearSelectedUserAction: clearSelectedUserDispatch,
    setSelectedUserAction: setSelectedUserDispatch,
    setUserPageAction: setUserPageDispatch,
  },
});

export const {
  setUserPageByDtoAction,
  clearSelectedUserAction,
  setSelectedUserAction,
  setUserPageAction,
} = userSlice.actions;

export const userState = (state: RootState) => state.user;

export default userSlice.reducer;
